<template>
  <AppDialog
    title="Disconnect SCIM provisioning?"
    :show="showConfirmation"
    size="medium"
    append-to-body
    position="centered"
    @close="hideConfirmation"
  >
    <template #default>
      <p>Are you sure you want to disconnect SCIM provisioning?</p>
      <ul class="mb-0 pl-20">
        <li>
          Your SCIM token will be deleted and can't be restored. Reconnecting generates a new one and requires
          reconfiguring your identity provider.
        </li>
        <li>Existing synced members, teams, and their data stay untouched.</li>
      </ul>
    </template>
    <template #footer>
      <div class="footer">
        <div class="buttons">
          <AppButton
            class="text-lighter"
            @click="hideConfirmation"
          >
            Cancel
          </AppButton>
          <AppButton
            type="danger"
            @click="confirmDisconnect"
          >
            Disconnect
          </AppButton>
        </div>
      </div>
    </template>
  </AppDialog>
</template>

<script>
export default {
  name: 'ScimDisconnectConfirm',
  props: {
    formId: { type: String, required: true },
    toggleId: { type: String, required: true },
  },
  data: () => ({
    form: null,
    showConfirmation: false,
    toggle: null,
  }),
  mounted() {
    this.toggle = document.getElementById(this.toggleId);
    this.form = document.getElementById(this.formId);

    if (!this.toggle || !this.form) {
      console.error(`Could not find toggle (${this.toggleId}) or form (${this.formId})`);

      return;
    }

    this.toggle.addEventListener('change', this.handleToggleChange, true);
  },
  beforeDestroy() {
    this.toggle?.removeEventListener('change', this.handleToggleChange, true);
  },
  methods: {
    handleToggleChange(event) {
      // Enabling stays one-click; only disconnecting needs a confirmation
      if (this.toggle.checked) {
        return;
      }

      // Capture-phase listener, so this runs before the fetch-submitting listener
      // wired in sso.js and keeps it from firing until the dialog is confirmed
      event.stopImmediatePropagation();
      this.toggle.checked = true;
      this.showConfirmation = true;
    },
    hideConfirmation() {
      this.showConfirmation = false;
    },
    confirmDisconnect() {
      this.toggle.checked = false;
      this.showConfirmation = false;
      // The form is fetch-driven (see sso.js); the native submit() would bypass its listener
      this.form.dispatchEvent(new Event('submit'));
    },
  },
};
</script>
